export function DoubleChevronUp({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="14"
        height="13"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.00001 2.81534L2.23627 7.07764L0.68042 5.33874L5.44416 1.07645C5.45445 1.06724 5.4649 1.05788 5.4755 1.04838C5.63183 0.908323 5.82139 0.738498 6.00519 0.61211C6.22881 0.458338 6.56185 0.2826 7.00001 0.2826C7.43818 0.2826 7.77122 0.458338 7.99484 0.61211C8.17864 0.738499 8.3682 0.908324 8.52453 1.04838C8.53513 1.05788 8.54558 1.06724 8.55587 1.07645L13.3196 5.33874L11.7638 7.07764L7.00001 2.81534Z"
          fill="#E74C3C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.00001 8.64884L2.23627 12.9111L0.68042 11.1722L5.44416 6.90994C5.45445 6.90074 5.4649 6.89138 5.4755 6.88188C5.63183 6.74182 5.82139 6.57199 6.00519 6.44561C6.22881 6.29183 6.56185 6.1161 7.00001 6.1161C7.43818 6.1161 7.77122 6.29183 7.99484 6.44561C8.17864 6.57199 8.3682 6.74182 8.52453 6.88188C8.53513 6.89138 8.54558 6.90074 8.55587 6.90994L13.3196 11.1722L11.7638 12.9111L7.00001 8.64884Z"
          fill="#E74C3C"
        />
      </svg>
    </span>
  );
}
